(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sv-product-duties"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sv-shipping-info')){
  customElements.define('sv-shipping-info',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-shipping-open]');this.closeButton=this.querySelector('[data-shipping-close]');
      const options={signal:this.controller.signal};
      this.trigger.addEventListener('click',()=>this.open(),options);
      this.closeButton.addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.addEventListener('close',()=>this.restore(),options);
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();},options);
    }
    disconnectedCallback(){this.controller?.abort();if(this.dialog?.open){this.dialog.close();this.restore();}}
    open(){if(this.dialog.open)return;this.previousOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';this.trigger.setAttribute('aria-expanded','true');this.closeButton.focus({preventScroll:true});}
    restore(){if(this.previousOverflow!==undefined){document.documentElement.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}this.trigger?.setAttribute('aria-expanded','false');if(this.trigger?.isConnected)this.trigger.focus({preventScroll:true});}
  });
}
  } catch(e) { console.error(e); }
})();

})();
